<div
    class="border-0 smallwidth cmps-widget-coaching-insight"
    *ngIf="!_hideWidget"
>
    <div
        class="card border-0"
        role="complementary"
        [attr.aria-labelledby]="compConfig?.id"
    >
        <div class="card-body">
            <div class="container-fluid mb-0">
                <div class="coaching-performer-container">
                    <div class="performer-stats-area">
                        <div class="performer-display">
                            <h3
                                class="pt-3 px-3 mb-0"
                                *ngIf="compConfig"
                            >
                                {{ compConfig?.header }}
                            </h3>
                            <div
                                class="p-2"
                                *ngIf="state?.user?.id"
                            >
                                <cmps-user-info
                                    [imageUrl]="_userImage"
                                    [username]="
                                        state?.user?.firstName +
                                        ' ' +
                                        state?.user?.lastName
                                    "
                                    (usernameClick)="onSelectUserClick($event)"
                                >
                                    <ng-template cmpsUserInfoLabels>
                                        <div
                                            cmpsUserInfoLabel
                                            *ngIf="state?.user?.superGroup"
                                        >
                                            {{ _i18n._9552_SG_ | translate }}
                                            {{ state?.user?.superGroup }}
                                        </div>

                                        <div
                                            class="cmps-widget-coaching-insight--user-info-viewing"
                                            cmpsUserInfoLabel
                                            *ngIf="_oaUser"
                                        >
                                            {{
                                                _i18n._9677_VIEWING_ | translate
                                            }}
                                            {{ _oaUser?.firstName }}
                                            {{ _oaUser?.lastName }}
                                        </div>
                                    </ng-template>
                                    <ng-template cmpsUserInfoBadges>
                                        <ng-container
                                            *ngIf="
                                                state?.selectedKpi
                                                    ?.kpiTypeId ===
                                                    _KpiType.COACHING_COVERAGE ||
                                                state?.selectedKpi
                                                    ?.kpiTypeId ===
                                                    _KpiType.OPPORTUNITY_ALIGNMENT ||
                                                state?.selectedKpi
                                                    ?.kpiTypeId ===
                                                    _KpiType.FRONT_LINE_OA
                                            "
                                        >
                                            <cmps-user-info-badge
                                                [label]="
                                                    _i18n._9676_OA_ | translate
                                                "
                                                [value]="
                                                    (_oaUser || state?.oaUser)
                                                        ?.oaScore == null
                                                        ? '-'
                                                        : ((
                                                              _oaUser ||
                                                              state?.oaUser
                                                          )?.oaScore / 100
                                                          | cmpsPercent
                                                              : '1.0-2')
                                                "
                                                [backgroundColor]="
                                                    (_oaUser || state?.oaUser)
                                                        ?.oaThresholdColour ||
                                                    '#000'
                                                "
                                                [textColor]="'#fff'"
                                                *ngIf="_oaUser || state?.oaUser"
                                            ></cmps-user-info-badge>
                                        </ng-container>
                                    </ng-template>
                                </cmps-user-info>
                            </div>
                        </div>
                    </div>
                    <div class="kpi-nav-area">
                        <div
                            cmpsCoachingNavigationBar
                            [insightSummaryData]="state?.insightSummaryData"
                            [selectedPeriodType]="state?.selectedPeriodType"
                            [selectedKpi]="state?.selectedKpi"
                            (selectionChange)="_onKpiChange($event)"
                            *ngIf="state?.insightSummaryData"
                        ></div>
                    </div>
                </div>

                <!--think of it as if human-insight was inside performance-insight-->
                <ng-container [ngSwitch]="state?.selectedKpi?.kpiTypeId">
                    <div
                        *ngSwitchCase="_KpiType.COACHING_COVERAGE"
                        cmpsCoachingCoverage
                        [context]="state?.coverageContext"
                    ></div>
                    <ng-container
                        *ngSwitchCase="_KpiType.OPPORTUNITY_ALIGNMENT"
                    >
                        <ng-container *ngTemplateOutlet="oaTpl"></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="_KpiType.FRONT_LINE_OA">
                        <ng-container *ngTemplateOutlet="oaTpl"></ng-container>
                    </ng-container>
                    <cmps-mi2-main
                        *ngSwitchCase="_KpiType.MANAGEMENT_IMPROVEMENT_INDEX"
                        [userId]="state?.user?.id"
                    ></cmps-mi2-main>
                    <cmps-coaching-wp-main
                        *ngSwitchCase="_KpiType.WINNING_PERCENTAGE"
                        [userId]="state?.user?.id"
                    ></cmps-coaching-wp-main>
                    <cmps-mi2-grid-main
                        *ngSwitchCase="_KpiType.FL_MANAGEMENT_IMPROVEMENT_INDEX"
                        (flmi2PersonChange)="_onMI2UserChange($event)"
                        [selecteduser]="state?.user?.id"
                    ></cmps-mi2-grid-main>
                    <cmps-fl-winning-grid-main
                        *ngSwitchCase="_KpiType.FL_WINNING_PERCENTAGE"
                        (flWinningPersonChange)="_onFLWPUserChange($event)"
                        [selectedUser]="state?.user?.id"
                    ></cmps-fl-winning-grid-main>
                    <div *ngSwitchDefault>
                        <div class="text-center">
                            {{ state?.selectedKpi?.kpiName }}
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-template #oaTpl>
    <cmps-widget-oa-sm
        [selectedFavouriteView]="{ userId: state?.user?.id }"
        (floaPersonChange)="_onOaUserChange($event)"
        [coachingInsightUserId]="state?.user?.id"
        [preferCoachingComponentTypeOA]="
            state?.selectedKpi?.kpiTypeId === _KpiType.OPPORTUNITY_ALIGNMENT
        "
        [periodTypeId]="state?.selectedPeriodType?.periodTypeId"
        [periodTypeDate]="state?.selectedPeriodType?.periodTypeDate"
    >
    </cmps-widget-oa-sm>
</ng-template>
